import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PulseLoader } from "react-spinners";
import Organs from "./Organs";
import { Checkbox } from "@mui/material";
const PaymentMeth = ({ methods, data }) => {
  const [state, setState] = useState({
    showDiscount: false,
    haveOrg: false,
    haveLegal: false,
  });
  useEffect(() => {
    const splash = localStorage.getItem("splash");
    const parsedSplash = JSON.parse(splash);
    const haveOrg =
      parsedSplash?.customer_info?.organ_document?.organ_document !== null
        ? parsedSplash?.customer_info?.organ_document?.organ_document?.find(
            (f) => f === "accepted",
          )
          ? false
          : true
        : data?.haveOrg;
    setState((perv) => ({
      ...perv,
      haveOrg,
      haveLegal: !!parsedSplash.legal_info,
    }));
  }, []);
  return (
    <div className="PaymentMeth">
      <Link to={"/shoppingCart"}>
        <div className="section">
          <span>مشاهده لیست خرید</span>
          <i className="icon-chevron-left" />
        </div>
      </Link>
      {data.hasTire ? (
        <div className="nationalCode">
          <h3>کد ملی</h3>
          <p>
            چون در سبد خرید شما کالای سامانه ای وجود دارد.برای خرید این محصول
            لطفا کد ملی خود را ثبت کنید
          </p>
          <input
            type="text"
            placeholder="کد ملی (ده رقمی)"
            value={data.nationalCode}
            onChange={methods.changeNationalCode}
          />
        </div>
      ) : null}

      <div
        className="section"
        onClick={() => {
          setState({ ...state, showDiscount: !state.showDiscount });
        }}
      >
        <span>وارد کردن کد تخفیف</span>
        <i className="icon-chevron-left" />
      </div>
      {state.showDiscount ? (
        <div className="discountCode">
          <input
            className="discountInput"
            placeholder="کد تخفیف"
            type="text"
            value={data.discountCode}
            onChange={methods.changeDiscoutCode}
          />
          {data.discountSubmited ? (
            <button
              className="discountButton"
              onClick={methods.clearDiscountCode}
            >
              {data.discountLoading ? (
                <PulseLoader color="#fff" size={10} />
              ) : (
                "حذف کد"
              )}
            </button>
          ) : (
            <button
              className="discountButton"
              onClick={methods.submitDiscountCode}
            >
              {data.discountLoading ? (
                <PulseLoader color="#fff" size={10} />
              ) : (
                "بررسی کد"
              )}
            </button>
          )}
        </div>
      ) : null}
      <div className="PaymentMethBody">
        <h3>نحوه پرداخت</h3>
        <p>روش پرداخت خود را انتخاب کنید</p>
        <div className="paymentBody">
          <div className="wrapper">
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
              }}
            >
              <div
                onClick={() => {
                  methods.changePaymentType(1);
                }}
                className={`payment  ${
                  data.selectedPayment === 1 ? "selected" : ""
                } `}
              >
                <div className="Head">
                  <div className="Img">
                    <img src="/public/assets/icons/card-tick.svg" alt="pic" />
                  </div>
                  <span>آنلاین</span>
                  <div className="Img tick ">
                    <img src="/public/assets/icons/tickk.svg" alt="pic" />
                  </div>
                </div>
                <span className="Text">
                  پرداخت آنلاین با تمامی کارتهای بانکی
                </span>
              </div>
              {data.selectedPayment === 1 ? (
                <>
                  <p>انتخاب درگاه بانکی</p>
                  <div className="Banks">
                    <div
                      className={`bank ${
                        data.selectedBank === 1 ? "selected" : ""
                      }`}
                      onClick={() => {
                        methods.changeBank(1);
                      }}
                    >
                      <img src="/public/assets/parsian-logo.png" alt="Bank" />
                    </div>
                  </div>
                </>
              ) : null}
            </div>
            {/* <div
            className={`payment  ${
              data.selectedPayment === 0 ? "selected" : ""
            } `}
            onClick={() => {
              methods.changePaymentType(0);
            }}>
            <div className='Head'>
              <div className='Img'>
                <img src='/public/assets/icons/card-pos.svg' alt='pic' />
              </div>
              <span>پرداخت در محل</span>
              <div className='Img tick '>
                <img src='/public/assets/icons/tickk.svg' alt='pic' />
              </div>
            </div>
            <span className='Text'>پرداخت آنلاین با تمامی کارتهای بانکی</span>
          </div> */}
          </div>
          {/* <div
            onClick={() => {
              methods.changePaymentType(6);
            }}
            className={`payment  ${
              data.selectedPayment === 6 ? "selected" : ""
            } `}
          >
            <div className="Head">
              <div className="Img">
                <img src="/public/assets/icons/card-tick.svg" alt="pic" />
              </div>
              <span>زرین پلاس</span>
              <div className="Img tick ">
                <img src="/public/assets/icons/tickk.svg" alt="pic" />
              </div>
            </div>
            <span className="Text">پرداخت قسطی</span>
          </div> */}

          {state.haveOrg ? (
            data.haveOrg ? (
              <>
                <div className="wrapper">
                  <div
                    onClick={() => {
                      methods.changePaymentType(0);
                    }}
                    className={`payment  ${
                      data.selectedPayment === 0 ? "selected" : ""
                    } `}
                  >
                    <div className="Head">
                      <div className="Img">
                        <img
                          src="/public/assets/icons/card-tick.svg"
                          alt="pic"
                        />
                      </div>
                      <span> اعتباری (سازمان های طرف قرارداد)</span>
                      <div className="Img tick ">
                        <img src="/public/assets/icons/tickk.svg" alt="pic" />
                      </div>
                    </div>
                    <span className="Text">
                      {" "}
                      در صورتی که عضو سازمان های طرف قرارداد کاچار هستید جنس خود
                      را ۶ قسط خریداری کنید
                    </span>
                    {/* <div
            className={`payment  ${
              data.selectedPayment === 0 ? "selected" : ""
            } `}
            onClick={() => {
              methods.changePaymentType(0);
            }}>
            <div className='Head'>
              <div className='Img'>
                <img src='/public/assets/icons/card-pos.svg' alt='pic' />
              </div>
              <span>پرداخت در محل</span>
              <div className='Img tick '>
                <img src='/public/assets/icons/tickk.svg' alt='pic' />
              </div>
            </div>
            <span className='Text'>پرداخت آنلاین با تمامی کارتهای بانکی</span>
          </div> */}
                  </div>
                </div>
                <span style={{ color: "#2f363d" }}>
                  کدملی درج شده در حواله باید با کدملی شخص خریدار و صاحب خودرو
                  یکی باشد در غیر این صورت سفارش شما لغو خواهد شد
                </span>
              </>
            ) : null
          ) : null}
        </div>
      </div>

      {data.selectedPayment === 0 ? (
        <Organs
          month={data.month}
          costs={data.costs}
          handleChangeOrgan={methods.handleChangeOrgan}
          handleFile={methods.handleFile}
          handleInstallmentMonth={methods.handleInstallmentMonth}
        />
      ) : null}
      <p onClick={methods.handleSubmit}>توضیحات</p>
      <textarea
        value={data.description}
        onChange={methods.changeDescription}
        placeholder="اگر توضیحی در خصوص سفارش خود دارید لطفا بفرمایید"
      ></textarea>

      <div className={"legalOrder"}>
        <div className={"legalTop"}>
          <div className={"legalCheckbox"}>
            <Checkbox
              onChange={(e) => methods.handleChangeNeedLegalFactor(e)}
              disabled={!state.haveLegal}
              checked={data.needLegalFactor}
              type="checkbox"
            />
            <span>سفارش حقوقی ثبت شود.</span>
          </div>
          {!state.haveLegal ? (
            <a href={"/legalInfo"}>
              <button disabled={state.haveLegal}>تکمیل اطلاعات حقوقی</button>
            </a>
          ) : null}
        </div>
        <div className={"legalBottom"}>
          <i className="icon-info-circle " />
          {state?.haveLegal ? (
            <span>
              با انتخاب این گزینه، فاکتور خرید شما به صورت حقوقی صادر خواهد شد.
              شما می‌توانید از قسمت سفارش در حساب کاربری خود،فاکتور خود را
              دریافت کنید.
            </span>
          ) : (
            <span>
              اطلاعات حقوقی شما ثبت نشده است. برای خرید به صورت حقوقی ابتدا
              اطلاعات حقوقی خود را در قسمت اطلاعات شخصی کامل کرده و سپس خرید خود
              را تکمیل کنید.
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default PaymentMeth;
